<template>
  <pt-poster-detail class="pt-poster-detail__page"></pt-poster-detail>
</template>

<script>
import PtPosterDetail from 'cps/tool-operation/pt-post-manage/pt-poster-detail/withData'
export default {
  name: 'pt-poster-detail__view',
  components: {
    'pt-poster-detail': PtPosterDetail
  }
}
</script>
